import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  content: string;
  image: string;
  slug: string;
  date: string;
};

export default function BlogCard({
  title,
  content: rawContent,
  image,
  slug,
  date,
}: Props) {
  const navigate = useNavigate();

  const content = useMemo(() => {
    const elem = document.createElement('div')
    elem.innerHTML = rawContent

    return elem.textContent ?? ''
  }, [rawContent])

  return (
    <button
      onClick={() => navigate(`/blogs/${slug}`)}
      className="h-full text-left"
    >
      <div
        className="
          flex h-full flex-col
          overflow-hidden rounded-xl
          border bg-white shadow-sm
          transition hover:-translate-y-1 hover:shadow-md
        "
      >
        {/* Image */}
        <div className="h-48 w-full overflow-hidden">
          <img
            src={image}
            alt={title}
            className="h-full w-full object-cover"
          />
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col p-6">
          <span className="text-xs text-gray-500">{date}</span>

          <h3 className="mt-2 text-lg font-semibold text-gray-900">
            {title}
          </h3>

          <p className="mt-3 flex-1 text-sm text-gray-600 line-clamp-3">
            {content}
          </p>

          <span className="mt-4 text-sm font-medium text-blue-600">
            Read more →
          </span>
        </div>
      </div>
    </button>
  );
}
